/**
 * Centralized Business Rules Configuration
 *
 * All magic numbers and business constants are defined here for:
 * - Easy auditing and modification
 * - Single source of truth across the app
 * - Clear documentation of business decisions
 */

// ─── Free Tier Daily Limits ──────────────────────────────────────
/** Maximum daily pantry scans for free-tier users */
export const FREE_DAILY_SCAN_LIMIT = 5;

/** Maximum daily recipe generations for free-tier users */
export const FREE_DAILY_RECIPE_LIMIT = 5;

/** Maximum daily manual ingredient additions for free-tier users */
export const FREE_DAILY_MANUAL_LIMIT = 5;

// ─── Trial Configuration ─────────────────────────────────────────
/** Trial period duration in days */
export const TRIAL_DURATION_DAYS = 7;

/** Trial period duration in milliseconds */
export const TRIAL_DURATION_MS = TRIAL_DURATION_DAYS * 24 * 60 * 60 * 1000;

// ─── Unlimited Indicator ─────────────────────────────────────────
/** Return value indicating unlimited access (premium users) */
export const UNLIMITED = -1;

// ─── Macro Limits Per Meal ───────────────────────────────────────
/** Maximum net carbs per meal for Keto diet */
export const KETO_MAX_CARBS_PER_MEAL = 12;

/** Maximum net carbs per meal for Low-Carb diet */
export const LOW_CARB_MAX_CARBS_PER_MEAL = 20;

// ─── Meal Plan Configuration ─────────────────────────────────────
/** Number of days in a weekly meal plan */
export const MEAL_PLAN_DAYS = 7;

/** Meals per day (Breakfast, Lunch, Dinner) */
export const MEALS_PER_DAY = 3;

/** Total meals in a weekly plan */
export const WEEKLY_MEAL_COUNT = MEAL_PLAN_DAYS * MEALS_PER_DAY;

// ─── Storage / Performance ───────────────────────────────────────
/** Debounce delay for localStorage writes (ms) */
export const LOCALSTORAGE_DEBOUNCE_MS = 300;

/** Maximum engagement events to store in localStorage */
export const MAX_ENGAGEMENT_EVENTS = 100;

/** Maximum beverage scan history entries */
export const MAX_SCAN_HISTORY = 10;

// ─── Caregiver Defaults ──────────────────────────────────────────
/** Default maximum meal prep time in minutes for quick meals */
export const DEFAULT_QUICK_MEAL_PREP_MAX = 20;
